/* tslint:disable:max-line-length */
const NOT_REGEX_ERROR = 'The characters "<" and ">" are forbidden';

const messages = {
  common: {
    phoneInput: 'Phone number',
  },
  cells: {
    cellSizeSmall: 'small cell',
    cellSizeMedium: 'medium cell',
    cellSizeLarge: 'large cell',
    unknown: '',
  },

  infoSaveMoney: {
    title: "Earn money",
    text1: "Get € 1 for each package received up to a maximum of 10€.",
    text2: " Having € 10 in the moneybox, Smart Point Girona will contact you to make the bank deposit.",
  },

  types: {
    crosstownRecipient: 'Send to a friend (recipient)',
    crosstownSender: 'Send to a friend (sender)',
    crosstown: 'Send to a friend',
    clickCollect: 'Click & collect',
    returns: 'Returns',
    external: 'Receive packages',
    publicDelivery: 'Receive packages',
    unknown: 'error',
    100: 'Send to a friend',
    200: 'Receive packages',
    300: 'Click & Collect',
    400: 'Returns',
  },

  status: {
    status: "Status",
    waitingActionRecipient: "Waiting action from recipient",
    waitingActionSender: "Waiting action from sender",
    readyToPickUp: "Ready to pick up",
    waitingOrderDestination: "Waiting order destination", // not used?
    inProgress: "Delivery in progress",
    completed: "Completed",
    unknown: 'error',
    0: 'discarded',
    90: 'completed',
    10: 'new',
    20: 'awaiting dropoff',
    30: 'awaiting collect',
    70: 'in deliver',
    50: 'processing',
    80: 'awaiting pickup',
  },

  history: {
    title: "History",
  },

  statusCallToAction: {
    awaitingDropoffSender: 'Place the package in the Smart Point to start',
    awaitingPickupRecipient: 'The shipment is ready, go to the Smart Point',
    awaitingHubSelectionRecipient: 'To receive your shipment, select a destination',
  },

  dialogExternal: {
    title: "Receive packages",
    intro: "Receive your packages free in less than 24 hours, at Zero Emissions delivery points throughout the city",
    list1: 'When you buy online use this shipping address',
    list2: 'Once the package arrives at our warehouse, we will deliver it to the Smart Point of your choice',
    list2_2: 'Once the package arrives at our warehouse, we will deliver it to your Smart Point',
    list2Button: 'Choose Smart Point',
    list2ButtonAlt: 'Choose another Smart Point',
    list3: 'You will receive an SMS with the link to open the Smart Point when the package is ready',
  },

  dialogNotAvailable: {
    title: "Not available",
    text: "Currently this option is not available",
  },

  serviceInterruption: {
    title: "Important",
    text: "To take a step forward we are doing maintenance",
    text2: "TEMPORARY INTERUPTION OF THE FREE DELIVERY SERVICE",
    text3: "We will shortly relaunch with our improved service",
  },

  dialogShipmentInfo: {
    orderNumber: "Order number",
    createdAt: "Created at",
    type: "Type",
    sent: "Sent",
    recipient: "Recipient",
    sender: "Sender",
    status: "Status",
    address: "Address",
    note: "Sender's note",
    selectOriginText: "to start the shipping, select an origin", // not used?
    selectOriginButton: "Select Origin", // not used?
    selectDestinationText: "To receive the shipment, select a destination", // not used?
    selectDestinationButton: "Select Destination", // not used?
    waitingRecipientText: "Waiting for the recipient to select a destination", // not used?
    yourOrderInHubText: "The package is ready, go to the Smart Point", // not used?
    openHub: "Open SmartPoint",
    selectHub: "Select SmartPoint",
    deliveringText: "Delivery in process", // not used?
  },

  dialogShipmentCancel: {
    title: 'Delete shipment',
    text: "You won't be able to undo this action",
    delete: "Delete",
    cancel: "Cancel",
  },

  dropupNotifications: {
    youHaveXNotif: "You have {numNot} notifications",
    youHave1Notif: "You have 1 notification",
    youHaveNoNotif: "You don't have notifications",
  },

  cards: {
    from: "from: {phone}",
    to: "to: {phone}",
    copied: "copied",
    address: "Address", // not used?
    selectDefaultDestination: "select default destination", // not used?
    note: "Note from sender", // not used?
    noteOwn: "Note to recipient", // not used?
    toBeDelivered: 'to be delivered', // not used?
    deliveryInProgress: 'delivery in progress',
    inLocker: 'ready for pickup', // not used?
    openHub: 'OPEN SMART POINT', // not used?
    selectDestination: 'In order to receive the shipment, select a destination', // not used?
    changeLocalization: 'CHANGE LOCATION', // not used?
    emptyActiveOrderList: 'Nothing here<br/>Create a new shipment!', // not used?
    selectDestinationHub: 'SELECT DESTINATION',
    awaitingDropoff: 'In order to start the shipment, leave the package in the Smart Point',
    awaitingPickup: `You can get your shipment from the Smart Point`,
    toBePickedUp: 'we are waiting for the recipient to pick up the shipment',
    sendAt: "Sent at:", // not used?
    // sendToAFriendOutgoing: `Send to a friend`,
    sendToAFriendOutgoing: `Shipment for`,
    // sendToAFriendIncoming: `Shipment from a friend`,
    sendToAFriendIncoming: `Shipment from`,
    externalIncoming: 'You have a shipment ',
    amazonReturns: 'Amazon returns',
    publicDelivery: 'You have a shipment ',
    clickCollectIncoming: 'You have a shipment ',
  },

  officeAddress: 'Center {code}, {address}',

  selectDefaultDestination: {
    selectDefaultFooter: `Select your favorite Smart Point.<br> Your orders will be delivered to this Smart Point by default`,
    selectDefaultFooterSingleHub: `This is your Smart Point.<br> Your orders will be delivered here`,
    createDeliveryAddress: 'CREATE DELIVERY ADDRESS',
    addressHelper: 'You have selected the Smart Point located in\n',
    selectOtherHub: 'SELECT ANOTHER SMART POINT',
    addressExplanation: 'COPY AND PASTE THIS ADDRESS IN ANY ONLINE SHOP TO GET YOUR ORDER' +
      ' DELIVERED TO THE CHOSEN SMART POINT',
    smsWarning: 'WE WILL NOTIFY YOU BY SMS',
    copyAddress: 'CLICK TO COPY THE ADDRESS',
    shippingNote: 'CREATE YOUR ADDRESS AND WHEN YOU RECEIVE YOUR ORDER YOU WILL SEE IT HERE',
    shippingButton: 'CREATE DELIVERY ADDRESS',
  },

  buttons: {
    next: 'NEXT',
    send: "SEND",
    loadMore: `LOAD MORE`,
    ok: 'OK',
    reopen: 'OPEN AGAIN',
    tryAgain: 'TRY AGAIN',
    cancel: 'CANCEL',
    done: 'DONE',
    getStarted: 'GET STARTED',
    finish: 'FINISH',
    receiverPhone: "RECEIVER'S PHONE",
    dropOffLocTime: "DROP-OFF LOCATION",
    confirm: "CONFIRM",
    update: "Update",
    pressAndHold: "PRESS<br/> &<br/> HOLD",
    copied: "COPIED",
  },

  haveYouOrder: {
    question: {
      text: 'DID YOU MADE YOU ORDER ALREADY?',
    },
    answer: {
      title: 'GREAT!',
      text: 'You will get an SMS with more information about the delivery and it will appear here',
    },
  },

  shipmentListTabs: {
    incoming: 'Incoming',
    outgoing: 'Outgoing',
  },

  inputAndButtons: {
    search: "Search",
    radioDontShow: "Dont show again help messages here",
  },

  // general errors
  errors: {
    validation: "This option is unable until you validate your telephone number",
    verification_code: 'There was an error in the verification. Are you sure that you are using the correct URL?',
    required: 'You must fill in this field',
    unknown: "Ooops, something unexpected happened.",
    contact: "Please get in contact with us",
    smsLimitReach: "Our phone lines are busy, please try again in a minute, or get in contact with us",
    shipment_load_error: "There was a problem loading this shipment",
    shipment_history_error: "There was a problem loading the history",
    general: {
      string: 'Minimum {0} characters',
      required: 'This field is required.',
      confirmed: 'Passwords don\'t match.',
      email: 'Please enter a valid email.',
      noCell: 'Sorry, this hub doesn\'t have compartments of this size. Select another size',
      cellWontOpen: 'Wow! An error occurred when trying to open the compartment. Please try again now or later.',
      not_regex: NOT_REGEX_ERROR,
      validation: {
        phone: 'Please enter a valid phone number.',
      },
    },

  },

  // Options

  dropUp: {
    uniqueAddressLabel: 'DELIVERY CENTER ADDRESS',
    uniqueAddressLabel2: 'MAKE THE ORDER PLACING THIS EXACT ADDRESS TO GET THE PACKAGE IN THE SELECTED HUB',
    selectOption: "SELECT AN OPTION BELOW",
    copied: 'copied',
    hubsButton: "CHECK ALL THE HUBS",
    crossTownDelivery: "CROSSTOWN DELIVERY",
    o: 'or',
    selectLockerSize: 'SELECT LOCKER SIZE',
  },

  drawer: {
    userMenu: {
      myProfile: "MY PROFILE",
      defaultHub: `MI SMART POINT`,
      euroSaved: "Earned: ",
      ceo2Saved: "{co2} KG of Co2 saved",
      history: 'HISTORY',
      howItWorks: "HOW IT WORKS",
      clickCollect: "CLICK&COLLECT PLUS",
      clickCollectLink: "https://smartpoint.city/en/click-en/",
      language: "LANGUAGE",
      signOut: "SIGN OUT",
      crossTownDelivery: "SEND TO A FRIEND",
    },
  },

  // pages

  home: {
    co2Saved: 'co2 SAVED',
    validationMsg: "This account has not been validated. Some of the options will not be available.",

    buttons: {
      buttonExternal: 'RECEIVE PACKAGES',
      buttonClickCollect: 'CLICK & COLLECT',
      buttonClickCollectCi: 'EL CORTE INGLÉS C&C',
      buttonCrosstown: 'SEND TO A FRIEND',
      buttonReturns: 'RETURNS',
    },
  },

  callUs: `PROBLEMS? CALL US`,

  shipmentNotes: {
    title1: "DESCRIBE WHAT YOU ARE SENDING",
    placeholder: "what are you sending?",
  },

  crosstownLoading: {
    title: 'ONE MOMENT PLEASE',
    comment: "We're making things happen",
    finishText: "We've booked a <b>{hubSize}</b> in <b>{hubAddress}</b> where you can drop your item",
    openHubBtn: "OPEN HUB NOW",
    goBackBtn: "DO IT LATER",
  },

  deliverySummary: {
    title: "YOUR DELIVERY SUMMARY",
    phone: "Recipient's phone number",
    dropoff: "Dropoff",
    size: "Size",
    deliveryLocation: "Delivery location",
    weTakeCare: "Don't worry, we'll take care of it!",
    payment: "Payment",
    note: "Note",
    confirmation: "Please confirm all info above is correct",
    phoneDisclaimer: "The recipient will see your telephone number",
    // leaving here as reference
    errors: {
      sameUser: 'It doesn\'t make sense to send a package to yourself',
    },
  },

  registerOnboarding: {
/// ******
    onboarding1: {
      text1: `<b class="xl">We welcome you to Smart Point Girona</b>`,
      text2: `A unique system to receive your packages at Smart Points throughout the city`,
    },

    onboarding2: {
      text1: ``,
      text2: `<b>When you make your online purchases, indicate in the delivery address space the location of ` +
        ` our logistics center</b>`,
    },

    onboarding3: {
      text1: '',
      text2: `<b>Once we receive your package, we will notify you with a message and ask you to choose a Smart Point` +
        ` to pick it up</b>`,
    },

    onboarding4: {
      text1: ``,
      text2: `<b>We take care of leaving your package at the Smart Point and we will notify you when it is ` +
        ` available</b> `,
    },
  },

  intro: {

    login: {
      title: 'LOGIN',
    },

    register: {
      title: 'REGISTER',
      registerUpText: "Enter your details to register",
      loginUpText: "Enter your details to login",

      registerDownText: 'Already have a profile?',
      registerLink: 'Register',

      loginDownText: "You don't have an account?",
      loginLink: 'Login',
    },

    done: {
      text1: "the first Zero emission package delivery and return app for your online purchases",
      text2: "never have issues with your deliveries ever again",
    },
  },

  sendReset: {
    text: "Insert your phone number and we will send you an SMS with a password recovery link",
    back: "Back to login",
    button: "Send",
    success: "SMS sent to the provided number",
  },

  reset: {
    title: "Change Password",
    text: "Insert your email and the new password to change it.",
    back: "Back to login",
    password: "New Password",
    button: "Change Password",
    success: "Your password has been changed successfully",
    errors: {
      401: `There was a problem changing the password`,
    },
  },

  validationView: {
    title: 'User validation',
    text: "Wait a moment while we validate your account",
    back: "Back to login",
    result: "Your account has been successfully validated",
    error: "There was an error validating your account",
    errors: {
      cantValidate: 'Your account could not be validated',
    },
  },


  registerForm: {
    namePlaceholder: "First name...",
    lastNamePlaceholder: "Last name...",
    phonePlaceholder: "Phone number...",
    emailPlaceholder: "Email address...",
    passwordPlaceholder: "Password...",
    passwordCreationPlaceholder: "Create your password...",
    rePasswordCreationPlaceholder: "Retype your password...",
    resendVerificationText: "This account has been registered already and needs validation",
    resendVerificationButton: "Send validation link",
    resendVerificationSuccess: "Validation link sent via SMS",
    tos_text: 'I accept',
    tos_link_text: 'terms and conditions of use',

    errors: {
      409: 'It seems you are already registered.',
      no_regex: NOT_REGEX_ERROR,
    },
  },

  loginForm: {
    forgotPassword: 'Forgot password',
    errors: {
      401: "Seems we cannot recognize you. Maybe you have forgotten your password?",
      not_regex: NOT_REGEX_ERROR,
    },
  },

  tos: {
    title: 'Terms and conditions of use',
    text: '<h4>General Delivery Conditions</h4>\n' +
        '<p>These data are required for the correct management of temporary custody and delivery of goods and services, and your data is protected in compliance with the General Data Protection Regulation (GDPR) (EU) 2016/679 and Ley Orgánica 3/2018, of December 5, on the Protección de Datos de Carácter Personal y Garantía de los Derechos Digitales (LOPD and GDD), on the protection of personal data.</p>\n' +
        '<h4>General features</h4>\n' +
        '<p>The service includes the collection, temporary custody and delivery of goods and services, in accordance with the agreed service and deadlines, at the selected terminal within the Lava Locker S.L. network of smart lockers under the Smart Point and/or Mayordomo brands (hereinafter ‘Smart Point’ and/or  ‘Mayordomo’).</p>\n' +
        '<h4>Delivery and collection system and Marketplace: Process</h4>\n' +
        '<p>All Users will be assigned a unique delivery code, which allows them to receive deliveries at the \'Smart Point\'. For each delivery received, the user will receive a collection code by email and SMS, provided that the registration is completed with a valid mobile number, which will need to be entered on the Smart Point device or on the web application https://mayordomo.io/w for the removal of merchandise from the locker within the maximum collection period, which is 72 hours unless otherwise reported. The user is responsible for the custody of said unique delivery code and personal collection codes, and the User may transfer them to a third party for the reception or shipment of a package. LAVA LOCKER, S.L. is not responsible for the use of said code.<br> For the delivery reception mode, the maximum weight is 30 kg. The maximum dimensions that shipments must meet in order to receive them will depend on the type of compartments (from small to large or long): <br> <br> Small: 360mm long x 105mm high x 520mm deep <br> Large: 360mm long x 360mm high x 520mm deep <br> Long: 360 mm long x 920 mm high x 520 mm deep <br> <br> Smart Point exempts itself from any responsibility regarding compliance with the delivery deadlines committed due to the unavailability of spaces according to the type of merchandise to be delivered at the selected locker, being the responsibility of the carrier that makes the delivery. Likewise, it is not responsible for damages, both in the packaging and in the content during its transport phase, in which other operators may have incurred. <br> For the use of the services available in the Smart Point Marketplace: the user will have to place their order through the application https://mayordomo.io/w/# or on the screen of the Smart Point smart locker, leaving their article/s or garment/s in the corresponding compartment when necessary. The prices of the services are detailed in the information of each service in the web application and on the Smart Point screen. The prices of each service can be modified without notification. If there is no specified price for a service and no notice is given to the contrary, such as the need to prepare an estimate, the service is free. Once an order has been placed, a confirmation of the order will be sent by email and SMS, from which the price cannot be modified. The user will also receive a link or be redirected to the corresponding page to pay the amount. If the order requires returning an item to the user, they will be delivered again to the Smart Point. <br></p>\n' +
        '<h4>Temporary custody of packages</h4>\n' +
        '<p>By registering for this service, the user authorizes LAVA LOCKER S.L. to the temporary custody of those packages that are delivered to the Smart Point with the user delivery code or as part of an order process.</p>\n' +
        '<h4>Verification of the nature</h4>\n' +
        '<p>Smart Point reserves itself the right to verify the nature and content of the packages that have been entrusted to it, including the use of X-rays, as well as to interrupt any delivery process already started if content appears that violates the provisions in force. Reserves itself also the right to photograph the packages that are deposited in their smart lockers in order to demonstrate their status in the event of hypothetical future claims; as well as making recordings of their terminals and operations in order to guarantee the correct provision of the service, its security and correct use.</p>\n' +
        '<h4>Excluded Merchandise</h4>\n' +
        '<p>The deposit of packages or objects whose content is contrary to law or public order is prohibited, incurring the client the corresponding responsibilities, and being LAVA LOCKER S.L. totally exempt from them for this reason. The deposit of weapons, replicas of weapons, ammunition, stolen articles, poisonous or infectious substances, cash, promissory notes, currency, checks, shares or participations, gold, silver ingots, stamps unless franked, biological samples, human remains, jewelry, toxic materials, drugs, animals and flammable or dangerous materials is prohibited. <br> Smart Point will not accept deliveries with cash on delivery service, those that require customs payment or those that require any additional payment. Finally, packages of more than 50 kg will not be accepted either.</p>\n' +
        '<h4>Refund Policy</h4>\n' +
        '<p>The user is entitled to a refund of the amount of their order placed on the Marketplace in the event that they inform Smart Point by email of their desire for a refund, before the service has been performed. Otherwise, no refund will be available. The client will receive an email confirming the amount of the service before starting the work. Cancellations must be reported in writing, sending an email to hola@smartpoint.ai. Cancellations informed by any other means will not be accepted.</p>\n' +
        '<h4>Cancellation policy</h4>\n' +
        '<p>Smart Point reserves the right to cancel an order if it is unable to fulfill said order. In the event that the order requires processing an item that the user has deposited in the Smart Point, the item will be delivered to the corresponding Smart Point locker without having been processed and the user will receive an email and SMS with an access code to pick it up.</p>\n' +
        '<h4>Days and hours of provision of services</h4>\n' +
        '<p>The Smart Points offer a deposit service twenty-four (24) hours, seven (7) days a week. This schedule may be altered depending on the accessibility of the location where the Smart Point terminal is located, as well as for reasons beyond Smart Point\'s control, such as failures in the coverage of mobile or electrical networks, leaving the provision of the delivery service subject to these.</p>\n' +
        '<h4>Payment Methods</h4>\n' +
        '<p>Payments for the services provided can be made with any type of credit or debit card, as long as it is accepted by Smart Point\'s payment method provider. Smart Point does not have access to or store sensitive data related to the means of payment used by the User/Client. Only the corresponding payment processing entity (payment method provider) has access to this data by way of managing payments and collections. Payments will be captured at the time the user enters the web page to verify the pending payment or automatically in the event that their data has been previously saved with the payment processing entity.</p>\n' +
        '<h4>Insurance conditions</h4>\n' +
        '<p>Maximum compensation limits for the loss or breakdown of transported goods and goods held in custody are as follows, in accordance with art. 57 of the LCTT (‘Ley de Contrato del Transporte Terrestre’): 1/3 of the daily IPREM (‘Indicador Público de Renta de Efectos Múltiples’) per kilogram, which implies a maximum compensation of €6.2767/kg, exclusively for the period that the package remains inside the Smart Point compartments. <br> The insurance will apply exclusively to merchandise. Documentation deliveries are insurable for the value of printing and not for the value of creation or realization. Compensation for used merchandise, in case of total loss, will suffer the depreciation corresponding to its current value, and in the case of partial breakage of the merchandise, the provisions of the damage appraisal will be indicated.</p>\n' +
        '<h4>Claim period</h4>\n' +
        '<p>For proper management in the processing of insurance, the claim for any damage or loss detected in the merchandise subject to custody or delivery to a Smart Point smart locker must be made by email hola@smartpoint.ai within a maximum period of seven (7) days, counting from the agreed time of delivery. <br> Smart Point is not part of the contractual relationship between the user and the Courier or Retailer in a parcel reception. The right of withdrawal or claim that, where appropriate, corresponds to the user as a consumer, must be exercised before the company with which the product or service was purchased to be deposited in the smart locker.</p>\n' +
        '<h4>Data Protection</h4>\n' +
        '<p>In compliance with the provisions of the General Data Protection Regulation (GDPR) (EU) 2016/679 and in Ley Orgánica 3/2018, of December 5, on the ‘Protección de Datos Personales y Garantía de Derechos Digitales’ (LOPD and GDD, Protection of Personal Data and Guarantee of Digital Rights) we inform you that the data provided by you, as well as those generated by the provision of the service by Smart Point to its customers, will be incorporated into the company\'s database, for the correct management of the delivery and subsequent information on promotions carried out. The legitimation will be based on the execution of a contract, legitimate interest and compliance with legal obligations. <br> The data will be kept for the time necessary for a correct provision of the service, as well as during the periods established for the fulfillment of legal obligations. In addition, transfers of personal data to third parties are not foreseen, except those necessary for the correct provision of the service, complying with the due confidentiality commitments with each of our suppliers or collaborators. <br> You can exercise the rights of access, rectification, deletion or forgetting, limitation, opposition, portability. To do this, you can send an email to dpo@lavalocker.es, or send a letter to Lava Locker S.L., at Calle Ramon Turró nº5 - 08005 - Barcelona, attaching a copy of your ID. <br> Likewise, the interested party can contact the competent Data Protection Control Authority (AEPD, in Spain) to obtain additional information or file a claim, as well as contact our Data Protection Delegate (ExpertosLOPD S.L.), at Calle Juan Flórez, 146, 15005, A Coruña or email: dpd@expertoslopd.es. For more information, you can consult the privacy policy of the person in charge at https://smartpoint.ai/politica-de-privacidad</p>\n' +
        '<h4>Use of Cookies</h4>\n' +
        '<p>http://mayordomo.io and http//smartpoint.ai may use cookies during the presentation of the website service. These cookies correspond to small text files that contain information and that the websites send to the Client/User\'s computer when they are browsing them. <br> In the event that the technologies used are not strictly necessary for the proper functioning of the service, they will not be executed without the prior consent of the User.</p>\n' +
        '<h4>Particular conditions of service</h4>\n' +
        '<h6>Food products:</h6>\n' +
        '<p>Food products purchased through the Marketplace are not trace-free. The user must take into account the possibility of allergies and intolerances. Smart Point will not assume any responsibility for the adverse reactions that Users may suffer derived from the products for whatever reason, including consumption contrary to the labeling or to the information indicated directly by the Establishment. The Establishment is the one who manufactures, elaborates, produces, processes, marks and treats the products. <br> In those cases in which the user wishes to know the composition and nutritional information of the products present in the Marketplace, they must contact each establishment directly for access to the complete information of the products. The User is aware and accepts that the descriptions and, where appropriate, the prices or photographs of the products and/or services offered in the Marketplace are based on the information and documentation provided by the establishments, for which Smart Point does cannot offer guarantees against possible inaccuracies in said descriptions, prices and/or photographs.</p>\n' +
        '<h6>Parapharmacy:</h6>\n' +
        '<p>Parapharmacy:</p>\n' +
        '<p>Users will not be able to order medications through the Marketplace. In the event that the user places an order related to medicines that are subject to the prohibition of being delivered electronically, the platform will cancel the order in accordance with the applicable legislation regarding the sale to the public of medicines for human use. Through the intermediation of Smart Point, only products related to parapharmacy can be requested. Smart Point is not responsible for the use made by Users of the requested products.</p>\n' +
        '<h6>Dry cleaning, laundry, clothing and shoe repairs:</h6>\n' +
        '<p>Smart Point puts the User in contact with the Establishments that process, clean, mend or repair the garments corresponding to the order. In case it is necessary to claim for quality to any of the Establishments, the conditions of the Establishment and the regulatory processes of each corresponding union will be applied. Smart Point will do everything possible to help in the mediation and resolution of incidents between the User and the Establishment.</p>\n' +
        '<h6>Keys and vehicles</h6>\n' +
        '<p>Smart Point is not responsible for possible costs and losses associated with the loss or defect of keys, such as keys to buildings or vehicles, beyond the limits mentioned in the \'Insurance Conditions\'.</p>\n' +
        '<h6>Conditions with Establishments in the Services Marketplace</h6>\n' +
        '<p>The User is aware and accepts that the descriptions and, where appropriate, the prices or photographs of the products and/or services offered in the Marketplace are made based on the information and documentation provided by the establishments, for which Smart Point cannot offer guarantees against possible inaccuracies in said descriptions, prices and/or photographs. <br> Likewise, the User accepts that all the products reflected in the Smart Point platform are subject to their availability and in this sense assumes the possibility of finding a product and/or service unavailable in the establishment during the execution of an order. Additionally, the price of the product may vary slightly due to changes at the point of sale. Smart Point reserves itself the right to proceed with the purchase in the event of variations in the price of up to 30%, if it exceeds the aforementioned 30%, Smart Point will contact the User to transmit the situation. <br> Smart Point reserves itself the right to withdraw any product from its platform, as well as to modify the content of its file at any time, without any type of responsibility being attributed to it. <br> Smart Point is not responsible for defects in intrinsic quality and quantities of products purchased from Marketplace establishments. Smart Point will make its best efforts to mediate between the User and the Establishment in the event of an incident or claim.</p>\n' +
        '<h4>Intellectual and industrial property</h4>\n' +
        '<p>All intellectual and industrial property rights over the website, the web application and its contents, including programming, design, applications, graphics, codes, text or images, trademarks, trade names, distinctive signs and other elements present therein belong exclusively to LAVA LOCKER S.L. Any reproduction, distribution, public communication (including making available), transformation or any other form of exploitation, even if citing the sources, is prohibited, except with the prior, express and written consent of LAVA LOCKER S.L.</p>\n' +
        '<h4>Complaint sheets</h4>\n' +
        '<p>THERE ARE COMPLAINT SHEETS AVAILABLE TO THE CONSUMER (DECREE 1/2010 OF January 14) which can be accessed at Ramon Turró 5, Barcelona 08005.</p>\n' +
        '<h4>Applicable legislation</h4>\n' +
        '<p>The present conditions will be governed by current Spanish legislation. The language used will be Spanish. <br> In the event of having to resort to the Courts to deal with any dispute between the parties, this will be done before the Courts and Tribunals of the city of Barcelona.</p>',
  },

  sendResetForm: {
    forgotPassword: `Can't remember my password`,
    errors: {
      401: `Looks like we can't recognice you. Maybe this is not y your email?`,
    },
  },

  thankYou: {
    title: "THANK YOU FOR USING SMART POINT GIRONA",
    text: "You've just saved",
  },

  openHub: {
    title1: "OPEN HUB",
    title2: "HUB IS OPEN",
    text1: "To open your hub press and hold this button",
    text2: "Please remember to close the hub",
    help: "IT DOESN'T OPEN? CALL US",
    addressLabel: 'your hub is in the following address',
    addressLabel2: 'make sure you are located in the proper address before opening the hub',
  },

  crossTownDelivery: {
    title: "Send to a friend",
    start: {
      title: 'We help you connect with the important people in your life. Leave your package at the Smart Point and' +
        ' we will deliver it to whoever you want.',
      text2_li_1: 'Leave it inside the Smart Point',
      text2_li_2: 'Tell us the telephone number of the recipient',
      text2_li_3: 'We deliver the package to where that person wants it to be',
    },
    cost: "COST OF SERVICE 1 EURO",

    receiverPhone: {
      title: "RECEIVER'S PHONE",
    },

    errors: {
      // put relevant errors here (same user etc) except global ones
      // look up errors in API ShipmentController
    },

  },

  amazonReturns: {
    title: 'Amazon Returns',
    start: {
      title: 'Forget taking packages to an office or waiting for the courier:',
      text2_li_1: 'Leave your package at the Smart Point, you don’t have to put a label on it.',
      text2_li_2: 'You receive an email from us requesting that you resend the Amazon return label to us by email.',
      text2_li_3: 'We return it to Amazon for you.',
    },
    notesLabel: "Return's information",
    summary: {
      title: "Return's summary",
      cellSize: 'cell size',
      address: "Shipping location",
      notes: "Return's information",
    },
  },

  clickAndCollect: {
    title: 'Click & Collect',
    start: {
      title: 'We go to any store in Girona to pick up your purchases.',
      text2_li_1: 'Buy in the store indicating that you will pick it up later',
      text2_li_2: 'Indicate the order details in our App',
      text2_li_3: 'We will pick it up for you and leave it at the Smart Point that you choose',
    },
    finish: 'Thanks',
    finish2: 'Your order is up and running. If the delivery person needs more information they will call you or send ' +
      'you an email. Once the package is at the Smart Point, you will receive an SMS to pick it up.',
    errors: {
      email_sent: `There was a problem sending the email`,
    },
    typeSelector: {
      client: "Next",
      shop: "I am a Shop",
    },
    label: {
      clientName: 'Client\'s name',
      shopName: 'Shop name',
      phoneNumber: 'User phone number',
      shopAddress: 'Shop\'s Address',
      addressToPickUp: 'Address where we should pick it up',
      comments: 'Additional info to pick up the order',
      smartpointDestination: 'Select the destination Smart Point',
    },
    placeholder: {
      shopName: 'name',
      phoneNumber: 'phone',
      addressToPickUp: 'Address',
      comments: 'Order id, pick up date...',
      smartpointDestination: 'Select the destination Smart Point',
    },
  },

  clickCollectCi: {
    title: "El Corte Inglés C&C",
    start: {
      title: 'We bring your orders from El Corte Inglés <em>FREE</em> to your Smart Point',
      text2_li_1: '<a href="https://www.elcorteingles.es/">Buy online</a> and select that you will pick it up later',
      text2_li_2: 'Send us the <a href="mailto:{officeEmail}">order details</a>',
      text2_li_3: 'We will pick it up for you from El Corte Inglés and leave it at your favorite Smart Point',
    },

    explanation: {
      title: 'How does it work?',
      li1: 'Place your order on the <a href="https://www.elcorteingles.es/">El Corte Inglés</a> website and chose <b>PICK-UP IN STORE / CLICK & CAR</b>',
      li2: 'After placing the order, select that SMART POINT GIRONA (telephone {officePhone}) will pick it up for you',
      li3: 'Forward the email you receive from El Corte Inglés to <a href="mailto:{officeEmail}">{officeEmail}</a> adding your user code {code}',
      li4: 'We will pick it up for you from El Corte Inglés and leave it at your favorite Smart Point.',
    },

    label:  {
      userName: 'Name',
      email: 'Email',
      shop: 'Shop',
    },

    form: {
      title: 'Summary',
      li1: 'When you press "send" we will send you an email with instructions on how to use the service.',
    },

    finish: {
      title: 'Thank you',
      text: `We've emailed you instructions on how to use the service.<br/><br/>Smart Point Girona<br/> technology for a greener city<br/>`,
    },
  },

  profile: {
    title: 'My profile',
    label: {
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      isVerified: 'The phone number has been confirmed',
      isNotVerified: 'We are waiting for you to confirm your phone number',
      language: 'Language',
      phone_number: 'Phone number',
      delivery_code: 'Delivery Code',
      member_since: 'Member since',
    },
    placeholder: {
      first_name: 'Enter your first name',
      last_name: 'Enter your last name',
      email: 'Your email',
      language: 'Prefered language',
      phone_number: 'Your phone number',
      delivery_code: 'Delivery Code',
      member_since: 'Member since',
    },
    member_since_format: 'DD MMMM, YYYY',
    copyDeliveryCode: 'Copy delivery code',
    deliveryCodeCopied: 'The delivery code has been copied to clipboard',
  },

  maps: {
    altText: "Select a Smart Point",
    confirm: 'CONFIRM',
    back: 'BACK',
  },

  installApp : {
    button: "Install app",
  },

  // no relevant errors to show apart un sections above
  //  there global fallback ones anyway (errors.general.xxx)
  // leaving here as reference
  // selectDestination: {
  //   errors: {}
  // },

  depositItem: {
    errors: {
      ReopenTimeLimitReachedException: 'The time available for reopen has ended',
    },
  },

  pickupItem: {
    errors: {
      ReopenTimeLimitReachedException: 'The time available for reopen has ended',
    },
  },

  cancelOrder: {
    errors: {
      shipmentCantBeCancel: "This shipment can't be deleted",
    },
  },
  // initStore: {
  //   errors: {}
  // },




};

export default messages;
